import styled, { css } from "styled-components";
import { FlexContainers, WrapperContainer } from "../../components";
import { colors, darkModeColors } from "../../consts";
import { TextWrapper } from "../TextOverflowWrapper/styled";

const DropdownOptionsAtTop = css`
  top: unset;
  bottom: 70%;
  transform-origin: bottom center;
`;

export const DropdownOptionsList = styled(FlexContainers.FlexColumnStart)`
  align-items: flex-start;
  position: ${(props) => (props?.isBlock ? "unset" : "absolute")};
  z-index: ${(props) => (props?.isBlock ? 0 : 100)};
  width: fill-available;
  margin-top: 4px;
  left: 0;

  top: 100%;

  ${(props) =>
    props?.visible ? "animation: growDown 300ms ease-in-out forwards" : "transform: scaleY(0)"};

  transform-origin: top center;

  ${(props) => props?.showAtTop && DropdownOptionsAtTop};

  background: ${darkModeColors.WHITE_RAISIN_100};
  border: 1px solid ${colors.RAISIN_100};
  overflow: auto;

  border-radius: 8px;
  padding: 4px;
  gap: 4px;

  max-height: 170px;
  ${(props) => props?.isBlock && "height: 100%"};
  ${(props) => props?.showScroll && `overflow-y: scroll; padding-right: 2px`};

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px 6px ${colors.RAISIN_50};
    border: 3px solid ${darkModeColors.WHITE_RAISIN_100};
  }

  ::-webkit-scrollbar-track-piece {
    margin-block: 0.25em;
  }
`;

const selectedOption = css`
  background: ${colors.RAISIN_100};

  p {
    color: ${colors.WHITE};
  }
`;

export const OptionButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-align: start;
  height: 40px;
  min-height: 40px;
  max-height: 40px;

  border-radius: 8px;

  width: 100%;

  padding: 0 8px;
  opacity: 1;

  ${(props) => props?.selected && !props?.showCheckboxes && selectedOption};

  &:hover {
    opacity: 1;

    ${(props) =>
      (!props?.selected || props?.showCheckboxes) && "background: rgba(52, 48, 61, 0.1);"};
  }

  ${(props) =>
    (!props?.selected || props?.showCheckboxes) &&
    props.active &&
    "background: rgba(52, 48, 61, 0.1);"};

  &:disabled {
    pointer-events: none;
  }
`;

export const OptionTextWrapper = styled(WrapperContainer)`
  width: 100%;
  overflow-x: hidden;

  ${TextWrapper} {
    font-size: 16px;
    line-height: 26px;
  }
`;
